<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      dark
      src="@/assets/img/bgDrawer.jpg"
    >
      <v-list>
        <v-list-item>
          <v-list-item-avatar>
            <img src="@/assets/img/logo.png" alt="Logo" />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title style="font-size: 13px;">保定怎诺智能科技有限公司</v-list-item-title>
            <!-- <v-list-item-subtitle>WEB</v-list-item-subtitle> -->
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider />

      <v-list dense>
        <v-list-item
          v-for="([icon, text, link], i) in items"
          :key="i"
          link
          @click="$vuetify.goTo(link)"
        >
          <v-list-item-icon class="justify-center">
            <a-icon :type="icon" style="font-size: 20px;" />
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="subtitile-1">{{
              text
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      app
      :color="color"
      :flat="flat"
      dark
      :class=" isXs ? { expand: flat }:['px-15',{ expand: flat }] "
    >
      <v-toolbar-title>
        <v-img src="@/assets/img/logo.png" max-width="50px" />        
      </v-toolbar-title>
        <div style="display: flex;flex-direction: column;" v-if="!isXs">
          <span style="font-size: 1.4rem;padding-left: 1rem;">保定怎诺智能科技有限公司</span>
          <span style="font-size: 0.7rem;padding-left: 1rem;">Baoding Zenow Intelligent Technology Co., Ltd</span>
        </div>
        <div style="display: flex;flex-direction: column;" v-if="isXs">
          <span style="font-size: 1.4rem;padding-left: 1rem;">怎诺智能</span>
          <span style="font-size: 0.7rem;padding-left: 1rem;">Zenow Intelligent</span>
        </div>
      <v-spacer />
      <div @click.stop="drawer = !drawer" v-if="isXs">
        <a-icon type="bars" style="font-size: 30px;" />
      </div>
      
      <div v-else>
        <v-btn text @click="$vuetify.goTo('#hero')">
          <span class="mr-2">首页</span>
        </v-btn>
        <v-btn text @click="$vuetify.goTo('#features')">
          <span class="mr-2">核心产品</span>
        </v-btn>
        <v-btn text @click="$vuetify.goTo('#download')">
          <span class="mr-2">下载中心</span>
        </v-btn>
        <v-btn text @click="$vuetify.goTo('#pricing')">
          <span class="mr-2">帮助文档</span>
        </v-btn>
        <v-btn rounded outlined text @click="$vuetify.goTo('#contact')">
          <span class="mr-2">联系我们</span>
        </v-btn>
      </div>
    </v-app-bar>
  </div>
</template>
<style scoped>
.v-toolbar {
  transition: 0.6s;
}

.expand {
  height: 80px !important;
  padding-top: 10px;
}

.title {
  font-size: 10px;
}
</style>

<script>
export default {
  data: () => ({
    drawer: null,
    isXs: false,
    items: [
      ["home", "首页", "#hero"],
      ["security-scan", "核心产品", "#features"],
      ["download", "下载中心", "#download"],
      ["question-circle", "帮助文档", "#pricing"],
      ["mail", "联系我们", "#contact"],
    ],
  }),
  props: {
    color: String,
    flat: Boolean,
  },
  methods: {
    onResize() {
      this.isXs = window.innerWidth < 850;
    },
  },

  watch: {
    isXs(value) {
      if (!value) {
        if (this.drawer) {
          this.drawer = false;
        }
      }
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
};
</script>
